/**
 * @classdesc Catalan Language Pack
 * @desc This class will used to translate tokens into the Catalan language.
 * @namespace Languages.Catalan
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Catalan
 */
export const dictionary = {
    'years' : 'Anys',
    'months' : 'Mesos',
    'days' : 'Dies',
    'hours' : 'Hores',
    'minutes' : 'Minuts',
    'seconds' : 'Segons'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Catalan
 */
export const aliases = ['ca', 'ca-es', 'catalan'];
